<div
  *ngIf="settings"
  class="form-group align-self-end color-picker-field-container {{
    getInputControlClasses()
  }} {{ settings.class }}"
>
  <label
    *ngIf="settings.label"
    for="input-{{ settings.fieldName.toString() | titlecase }}"
  >
    {{ settings.label }}
    <span *ngIf="required" class="text-danger">*</span>
  </label>
  <div
    [ngClass]="{
      'd-flex input-group': true
    }"
    [class]="settings.customInputClass"
  >
    <input
      id="input{{ settings.fieldName | titlecase }}"
      name="input{{ settings.fieldName | titlecase }}"
      type="color"
      class="form-control color-picker-field {{
        control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
      }} {{ required ? 'required' : '' }} {{
        data && settings.showFieldHasValue === true ? 'filled-out' : ''
      }}"
      [disabled]="disabled"
      [tooltip]="settings.tooltip"
      [(ngModel)]="data"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    />
    <input
      id="input{{ settings.fieldName | titlecase }}"
      name="input{{ settings.fieldName | titlecase }}"
      type="text"
      class="form-control {{
        control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
      }} {{ required ? 'required' : '' }}"
      [placeholder]="settings.placeholder ? settings.placeholder : ''"
      [required]="required"
      [disabled]="disabled"
      [tooltip]="settings.tooltip"
      [(ngModel)]="data"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    />
    <div class="input-group-append">
      <button
        type="button"
        class="input-group-text"
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        (click)="onClearInput()"
        [disabled]="disabled"
      >
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message">
    <span *ngIf="required && !data && showError">
      {{ settings.label }} is required.
    </span>
    <span *ngIf="!(required && !data) && showError">
      {{ errors[0] }}
    </span>
  </div>
</div>
